import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {
  @Input() featuresArray: any = {};
  @Output() featuresToSend = new EventEmitter<{}>();
  features: any = [];
  selectAllCheck: boolean = false;

  constructor(private dialog: MatDialogRef<FeaturesComponent>) { }

  ngOnInit() {
    console.log(this.featuresArray)
    this.featureInit();
  }

  featureInit() {
    this.featuresArray.selectedFeatures.forEach(element => { // loop for features
      const temp: any = {
        subFeatures: []
      };
      temp.name = element.name;
      temp._id = element._id;
      temp.showHide = true;
      temp.checked = element.checked || false;

      if (element.auth_children && element.auth_children.length) {
        element.auth_children.forEach(item => { // loop for sub-features
          const temp1: any = {};
          temp1.name = item.name;
          temp1._id = item._id;
          temp1.checked = item.checked || false;
          temp.subFeatures.push(temp1);
        });
      } else if (element.subFeatures && element.subFeatures.length) {
        element.subFeatures.forEach(item => { // loop for sub-features
          const temp1: any = {};
          temp1.name = item.name;
          temp1._id = item._id;
          temp1.checked = item.checked || false;
          temp.subFeatures.push(temp1);
        });
      }

      this.features.push(temp);
    });
    this.preSelect();
  }
  preSelect() {
    this.features.forEach(element => {
      this.featuresArray.preSelectedFeatures.forEach(ele => {
        if (ele._id === element._id) {
          element.checked = true;
          element.subFeatures.forEach(s => {
            s.checked = true;
          });
        }
      });
      element.subFeatures.forEach(fun => {
        this.featuresArray.preSelectedSubFeatures.forEach(ele => {
          if (ele._id === fun._id) {
            fun.checked = true;
          }
        });
      });
    });
  }
  featureSelect(feature) {
    feature.subFeatures.forEach(element => {
      element.checked = feature.checked;
    });

  }

  subfeatureSelect(feature) {
    let check = true;
    feature.subFeatures.forEach(element => {
      check = check && element.checked;
    });
    feature.checked = check;
  }

  submit() {
    this.featuresToSend.emit(this.features);
  }

  closeDialog() {
    this.dialog.close();
  }
  selectAll(){
    this.selectAllCheck = !this.selectAllCheck;
    this.features.forEach(element => {
      element.checked = this.selectAllCheck;
      element.subFeatures.forEach(element => {
        element.checked = this.selectAllCheck;
      });
    });
}
}
